'use strict';

import $ from 'jquery';
import tyreselector from './tyreselector-4';
import 'select2';

let tyreselectorSize = {

  form: $('form[name="sizeSearchForm"]'),
  keys: ['width','height','rim'],
  get selects (){ return this.form.find('select'); },
  get widthEl (){ return this.selects.filter('[name="width"]'); },
  get heightEl (){ return this.selects.filter('[name="height"]'); },
  get rimEl (){ return this.selects.filter('[name="rim"]'); },
  get clearBtn (){ return $(this.form).find('.clearBtn'); },
  data: typeof( window.sizeData ) !== 'undefined' ? window.sizeData : false,
  sortValues: {
    // these are the values used to limit options
    width: undefined,
    height: undefined,
    rim: undefined,
    initialKey: undefined // if only one select element has value then this gets the select's name
  },

  populateSelects: function(init){

    var self = this,
      refreshResults = false;


    $(self.selects).each(function(selectIndex){
      var selectEl = $(this),
        val = $(this).val() ? ~~$(this).val() : $(this).val(), // convert to number if value is set
        keyIndex = self.keys.indexOf($(this).attr('name')),
        curKey = self.keys[keyIndex],
        storedVal = window.cookieObj[curKey],
        selectedKeys = [],
        definedCount = 0,
        initialKey = null,
        nextSelect = self.selects[keyIndex+1];

      // new feature: first select should always be enabled, others get enabled one-by-one by users choices
      // if current select has no value, reset next select and remove it's value from localStorage

      if( !storedVal && nextSelect ){
        var nextKey = self.keys[keyIndex+1];
        $( nextSelect ).val('').prop('disabled',true);
        if( window.cookieObj && window.cookieObj[nextKey]){
          self.sortValues[nextKey] = undefined;
          delete window.cookieObj[nextKey];
          if( window.setTyreCookie ) window.setTyreCookie();
          // values have changed, refresh results after selects loop.
          refreshResults = true;
        }
      }
      else if( !storedVal && keyIndex === 0){
        self.sortValues[self.keys[keyIndex]] = undefined;
        delete window.cookieObj[self.keys[keyIndex]];
        refreshResults = true;
      }
      else if( storedVal && nextSelect ){
        $(self.selects[keyIndex+1]).prop('disabled',false);
      }

      // loop keys
      for(var i=0;i<self.keys.length;i++ ){
        if( self.sortValues[self.keys[i]] !== undefined ) { definedCount++; initialKey = self.keys[i]; selectedKeys.push(self.keys[i]); }
      }

      if( definedCount === 1 ) self.sortValues.initialKey = initialKey;
      else self.sortValues.initialKey = undefined;

      var curVal = -1,
        options = [],
        values = [],
        nothingSelected = self.sortValues.width === undefined && self.sortValues.height === undefined && self.sortValues.rim === undefined ? true : false,
        readyToSubmit = self.sortValues.width !== undefined && self.sortValues.height !== undefined && self.sortValues.rim !== undefined ? true : false;

      var submitEls = $(this).parents('form').find('input[type="submit"],button[type="submit"]');

      if( !readyToSubmit ) $(submitEls).prop('disabled',true);
      else $(submitEls).prop('disabled',false);

      /* loop thru sizeData search for matches */
      for( i=0;i<self.data.length;i++ ){

        /* check that data is valid */
        var valid = true;
        for(var j=0;j<self.keys.length;j++ ){
          var valCheck = self.data[i][keyIndex];
          if( typeof( valCheck ) === 'undefined' || valCheck === '' || isNaN(valCheck) || valCheck === 0 ){
            valid = false;
          }
        }

        if( !valid ) {
          console.warn('window.sizeData not valid:',window.sizeData[i]);
        }
        else {
          /* from data object get the value that matches <select> elements 'name' attribute's index in keys */
          curVal = self.data[i][keyIndex];

          /* if nothing is selected or this is the first select to be populated */
          if( nothingSelected || self.keys[keyIndex] === self.sortValues.initialKey ){
            /* show only unique options */
            if( values.indexOf(curVal) === -1 ){
              values.push(curVal);
            }
          }
          /* filter options by selection */
          else {
            /* compare data item's values to "sortValues" object's values */
            var selectedKeysMatched = 0;
            for(var ii=0;ii<selectedKeys.length;ii++ ){
              if( self.data[i][self.keys.indexOf(selectedKeys[ii])] === ~~self.sortValues[selectedKeys[ii]] ){selectedKeysMatched++;}
            }
            /* if all defined values matched, AND current value is not yet in array, then add this element to options */
            if( selectedKeysMatched === selectedKeys.length && values.indexOf(curVal) === -1 ){
              values.push(curVal);
            }
          }
        }// else
      } // dataloop

      /* sort values ascending  */
      values.sort(function(a,b){
        if(a<b) return -1;
        if(b<a) return 1;
        return 0;
      });

      // create <option> elements and store them to an array
      for( i=0;i<values.length;i++ ){
        addOption(values[i],values[i] === val);
      }

      function addOption(value,selected) {
        var option = $('<option>'+value+'</option>');
        option.attr('value',value);
        if( selected ){
          option.attr('selected','selected');
        }
        options.push(option);
      }

      // clear all but first option from current <select> element
      $(selectEl).find('option').not(':first').remove();

      // populate select
      $(selectEl).append(options);
    }); // selects

    if( refreshResults ){
      if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults('size.populateSelects()'); // this updates header as well
    }

    // check if tyre size data is stored in cookie
    // and that the size is found in sizeData
    // and that user has not chosen model or license
    // if all are true, then pre-select values to select-elements.
    if( init && window.cookieObj && !window.cookieObj.license && !window.cookieObj.model ){

      if( self.data && (typeof( window.cookieObj.width ) !== 'undefined' || typeof( window.cookieObj.height ) !== 'undefined' || typeof( window.cookieObj.rim ) !== 'undefined') ) {

        for( var i=0;i<self.data.length;i++ ){
          if( self.data[i][self.keys.indexOf('width')] === window.cookieObj.width && self.data[i][self.keys.indexOf('height')] === window.cookieObj.height && self.data[i][self.keys.indexOf('rim')] === window.cookieObj.rim ){
            self.sortValues.width = self.data[i][self.keys.indexOf('width')];
            self.sortValues.height = self.data[i][self.keys.indexOf('height')];
            self.sortValues.rim = self.data[i][self.keys.indexOf('rim')];

            $(self.widthEl).val(self.data[i][self.keys.indexOf('width')]);
            $(self.heightEl).val(self.data[i][self.keys.indexOf('height')]);
            $(self.rimEl).val(self.data[i][self.keys.indexOf('rim')]);
            self.populateSelects();
            break;
          }
        }
      }

    } // init

    if( self.sortValues.width === undefined && self.sortValues.height === undefined && self.sortValues.rim === undefined ) self.resetClear(false); // $(clearBtn).toggleClass('active',false);
    else if( !init && self.sortValues.width && self.sortValues.height && self.sortValues.rim ){
      // user has selected all 3 values

      //$(clearBtn).toggleClass('active',true);
      self.resetClear(true);
      window.cookieObj.width = self.sortValues.width;
      window.cookieObj.height = self.sortValues.height;
      window.cookieObj.rim = self.sortValues.rim;

      /* remove other searches, this is by customer's request */
      if( window.cookieObj.license ) delete window.cookieObj.license;
      if( window.cookieObj.manufacturer ) delete window.cookieObj.manufacturer;
      if( window.cookieObj.year ) delete window.cookieObj.year;
      if( window.cookieObj.model ) delete window.cookieObj.model;
      if( window.cookieObj.vehicle ) delete window.cookieObj.vehicle;
      if( window.cookieObj.id ) delete window.cookieObj.id;
      if( window.cookieObj.productInfo ) delete window.cookieObj.productInfo;
      if( window.cookieObj.productName ) delete window.cookieObj.productName;

      window.setTyreCookie();

      if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults('size:populateSelects(): user has selected all 3 sizes'); // this updates header as well

      if( typeof tyreselector.resetTyreSelectorForms === 'function' ) tyreselector.resetTyreSelectorForms(['licenseSearchForm','modelSearchForm']);
    }
    else {
      self.resetClear(true);
    }

  }, // populateSelects

  resetClear: function(visibility){
    var self = this;

    if( typeof visibility === 'undefined' ) return false;
    if( visibility ) $(self.clearBtn).slideDown('fast');
    else $(self.clearBtn).slideUp('fast');
  }, // resetClear


  resetSizeForm: function(){
    this.resetForm();
    return true;
  },

  resetForm: function(){
    var self = this;

    if(!window.cookieObj.manufacturer){
      window.cookieObj.width = undefined;
      window.cookieObj.height = undefined;
      window.cookieObj.rim = undefined;

      window.setTyreCookie();
    }
    if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults('size.resetForm()'); // this updates header as well

    $(self.selects).each(function(){
      var name = $(this).attr('name');
      self.sortValues[name] = undefined;
      $(this).val(''); //$(this).select2('val','');
    });

    self.populateSelects();
    /* customer wants clear button to refresh all user data */

  }, // resetForm();

  init: function(){
    console.log('TS4: tyreselectorSize.init()');

    var self = this;

    tyreselector.sizeForm = self;

    $(self.selects).each(function () {
      var $select = $(this);

      $(this).select2({
        minimumResultsForSearch: 3,
        language: {
          noResults: function() {
            return $select.data('no-results') || 'No results found';
          }
        }
      });
    });

    if( !self.data ) return;

    $(self.selects).each(function(){

      $(this).on('change',function(){
        var val = $(this).val(),
          name = $(this).attr('name');

        if( val === '' ) val = undefined;
        // update cookie
        window.cookieObj[name] = val ? ~~val : val; // if val has value, convert it to a number
        window.setTyreCookie();

        // filter select elements
        if( val === '' ) val = undefined;
        self.sortValues[name] = val ? ~~val : val; // if val has value, convert it to a number
        self.populateSelects();

      });
    });

    $(self.clearBtn).each(function(){
      $(this).removeAttr('style');
    }).on('click', function(e){
      e.preventDefault();
      if( typeof tyreselector.resetTyreSelectorForms === 'function' ){
        tyreselector.resetTyreSelectorForms();
      }
      else {
        self.resetForm();
      }
    });

    // populate + pre-select
    self.populateSelects(true);

  }, // init

};

export default tyreselectorSize;
